import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-maes-diogelwch-brec',
    templateUrl: './maes-diogelwch-brec.component.html',
    styleUrls: ['./maes-diogelwch-brec.component.scss'],
    imports: [FormlyModule]
})
export class MaesDiogelwchBrecComponent extends FieldType<FieldTypeConfig> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {

  }
}
